import {
  Box,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text
} from '@chakra-ui/react';
import { Button, Modal } from '@morressier/alembic';

type IEvent = {
  name: string;
  event: string;
};

interface Props {
  onClose: () => void;
  isOpen: boolean;
  loadingState: boolean;
  defaultEventDetail: IEvent;
  onConfirmChange: () => void;
}

export default function DefaultEmailTemplateModal({
  onClose,
  isOpen,
  loadingState,
  defaultEventDetail,
  onConfirmChange
}: Props) {

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={{ base: 'calc(100vw - 16px)', md: '720px' } as any}>
      <ModalHeader>Change Default Template</ModalHeader>

      <ModalBody>
        <Box>
          <Text mb={4}>
            The event - <strong>{defaultEventDetail.event}</strong> to which this
            template belongs to has a default template{' '}
            <strong>{defaultEventDetail.name}</strong>
          </Text>
          <Text>
            Are you sure you want to change the default template? This will
            override the current default.
          </Text>
        </Box>
      </ModalBody>

      <ModalFooter>
        <Button variant="secondary" mr={3} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onConfirmChange}
          isLoading={loadingState}
          isDisabled={loadingState}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
}
